module.exports = __webpack_public_path__ + "img/title-bg.b83c48fa.png";